var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-result',{attrs:{"status":"404","title":"404","sub-title":_vm.$t('Sorry, the page you visited does not exist.')},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(_vm._s(_vm.$t('Back Home')))])]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }